import isEqual from 'lodash.isequal'
import { FightSetup, FullFight } from 'web/data/models'

export function areFightsEqual(fight1: FullFight, fight2: FullFight) {
    const { createdAt: _, updatedAt: __, ...rest1 } = fight1.fight
    const { createdAt: ___, updatedAt: ____, ...rest2 } = fight2.fight

    return isEqual({
        ...fight1,
        fight: rest1
    }, {
        ...fight2,
        fight: rest2
    })
}

export function areSetupsEqual(setup1: FightSetup, setup2: FightSetup) {
    const { createdAt: _, updatedAt: __, ...rest1 } = { ...setup1 }
    const { createdAt: ___, updatedAt: ____, ...rest2 } = { ...setup2 }

    return isEqual(rest1, rest2)
}
